module.exports = __webpack_public_path__ + "img/4.2b440c67.png";